module.exports = __webpack_public_path__ + "fonts/TelefonicaCapWeb-Regular.8e213c6a.eot";